angular.module('lf.desktop')

.factory('popupsService', function ($rootScope, $parse, $compile, $http, i18n, preloadData, gtmService) {
  var popups = {};

  var popupsService = {
    
    register: function (name) {
      if (popups[name]) {
        throw new Error('Popups Service (register): duplicate popup name `' + name + '`');
      }
      popups[name] = true;
    },
    
    unregister: function (name) {
      if (!popups[name]) {
        throw new Error('Popups Service (unregister): there is now such popup `' + name + '`');
      }
      delete popups[name];
    },
    
    show: function (name) {
      if (typeof name === 'string') { // html inlined
        $rootScope.$broadcast('popup:show', {name: name});
      } else if (typeof name === 'object') { // ajax
        var opts = name;
        var className = '';

        if (!opts.name) {
          throw new Error('Popup Service: [show (ajax)] popup component should have `name` (e.g. `{name: \'hello\'}`)');
        }
        
        opts.destroyOnHide = true;
        
        var $popup = $('<div></div>')
          .attr('popup', opts.name)
          .attr('popup-options', JSON.stringify(opts))
          .attr('ng-cloak', '');

        $('body').append($popup);

        if (opts.url) { // ajax
          if (opts.className) {
            className = opts.className;
            delete opts.className;
          }
          
          var loadingContent = '<div class="ui-popup__loading"><img class="spinner" src="' + preloadData.imagesPath + '/spinner-48x48.gif" /></div>';
          $popup.html(loadingContent);
          
          $compile($popup)($rootScope);
          $rootScope.$broadcast('popup:show', {name: opts.name});
          
          $http[opts.method || 'get'](opts.url, opts.data || {})
            .success(function (data) {
              $rootScope.$broadcast('popup:update', {
                name: opts.name,
                content: data,
                className: className,
                position: true
              });
            })
            .error(function () {
              var errorMessage = 'Error while loading remote content.';
              var errorContent = '<div class="ui-popup__error"><i class="fa fa-exclamation-triangle"></i>' + errorMessage + '</div>';
              $rootScope.$broadcast('popup:update', {
                name: opts.name,
                content: errorContent,
                position: true
              });
            });
        } else if (opts.content || opts.element) { // dynamic content
          if (opts.content) {
            $popup.html(opts.content);
          }
          
          if (opts.element) {
            $popup.append($(opts.element));
          }
          
          $compile($popup)($rootScope);
          $rootScope.$broadcast('popup:show', {name: opts.name});
        }
      }
    },
    
    showError: function (text) {
      if (!text) {
        text = '<b>' + i18n.notify.generalErrorTitle + '</b><br />' + i18n.notify.generalErrorText;
      }
      this.show({
        name: 'error' + (new Date()).getTime() + (Math.random() * 1e3 | 0),
        content: '<div class="ui-popup__error"><i class="fa fa-exclamation-triangle"></i>' + text + '</div>'
      });
    },
    
    showVideo: function (opts) {
      var isMobileClient = /ip(ad|hone|pod)|android/i.test(navigator.userAgent);
      
      opts = opts || {};
      
      if (!opts.url) {
        throw new Error('popupsService.showVideo(...): `url` is required');
      }

      var videoUrl = opts.url;
      if (videoUrl.slice(0, 2) === '//') {
        var protocol = document.location.protocol === 'https:' ? 'https:' : 'http:';
        videoUrl = protocol + videoUrl;
      }
      
      if (isMobileClient) {
        setTimeout(function () {
          window.location.href = videoUrl;
        }, 500);

        gtmService.pushVideoActivity({
          action: 'Play',
          url: videoUrl,
          prodId: opts.productId
        });
        
        return;
      }
      
      var id = String(Date.now()) + (Math.random() * 1e5 | 0);
      var name = opts.name || 'video-player-' + id;
      var $popup = $('<div></div>');
      var $videoPlayerContainer = $('<div video-player></div>');

      $popup
        .attr('popup', name)
        .attr('popup-options', JSON.stringify({
          className: 'ui-popup__modal_video-player',
          destroyOnHide: true
        }));

      $videoPlayerContainer
        .attr('video-player', JSON.stringify({
          url: videoUrl,
          autoPlay: true
        }));
      
      $popup.append($videoPlayerContainer);
      
      $('body').append($popup);
      $compile($popup)($rootScope);

      popupsService.show(name);
    },

    hide: function (name) {
      $rootScope.$broadcast('popup:hide', {name: name});
    }
  }
  
  return popupsService;
});

angular.module('lf.desktop')
/* 
 * This is a dummy service that I am inserting here because I want to be able to re-use 
 * lf.common.AccountCtrl in both mobile and desktop versions which uses popups 
 * only in mobile version. 
 * 
 * If I don't have this dummy service in desktop version then compilation would fail in desktop.
 * 
 * Ideally, we should rename "$popups" service defined in mobile layer to "popupsService" 
 * (and it's references across mobile layer to avoid this dummy service.)
 * */
.factory('$popups', function ($rootScope) {
	  return {
	    register: angular.noop,
	    unregister: angular.noop,
	    show: angular.noop,
	    hide: angular.noop
	  }
});
